import { Model, modelRegistry } from './Model';
export class Role extends Model {
    static entity = 'roles';
    id = null;
    name = null;
    created_at = null;
    updated_at = null;
    permissions = [];
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            permissions: this.attr([])
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
}
export default Role;
modelRegistry.register('Role', Role);
//# sourceMappingURL=Role.js.map